module.exports = __webpack_public_path__ + "static/media/consdata.9a32391a.png";